export const CATEGORY = {
  value1: "001",
  value2: "002",
  value3: "003",
};
